import React from "react";
import { GridColumn, GridContainer, GridRow } from "arv-reactcomponents";
import { OrderConfirmation } from "npmlinks-constants";
import PropTypes from "prop-types";

const { ORDERCONFIRMPAGE } = OrderConfirmation;

const OrderDeliveryDetails = ({ deliveryAddressDetails }) => (
  <GridContainer className="nw-orderconfirm-deliverydetails-block">
    <GridRow className="nw-orderconfirm-deliverydetails">
      <GridColumn className="nwc-grid-col-sm-3 nwc-grid-col-xs-12 nw-orderconfirm-deltypedetails">
        <span className="nw-orderconfirm-deltype-title">
          {ORDERCONFIRMPAGE.ORDER_DELIVERY_DETAILS.TITLE}
        </span>
        <p className="nw-orderconfirm-deltype-subtitle">
          {ORDERCONFIRMPAGE.ORDER_DELIVERY_DETAILS.SUB_TITLE_TEXT}
        </p>
      </GridColumn>
      <GridColumn className="nwc-grid-col-sm-6 nw-orderconfirm-deliverydetails-info-col">
        <address className="nw-orderconfirm-address">
          <div className="nw-orderconfirm-addressusername nw-orderconfirm-deliverydetails-info">
            {deliveryAddressDetails.name}
          </div>
          <div>{deliveryAddressDetails.address}</div>
          <div className="nw-orderconfirm-deliverydetails-info">
            {deliveryAddressDetails.city} , {deliveryAddressDetails.pincode}
          </div>
          <div className="nw-orderconfirm-deliverydetails-info">
            <i className="icomoon-mobile nw-orderconfirm-addressicons" />
            {deliveryAddressDetails.mobileNumber}
          </div>
        </address>
      </GridColumn>
    </GridRow>
  </GridContainer>
);

OrderDeliveryDetails.propTypes = {
  deliveryAddressDetails: PropTypes.object.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderDeliveryDetails,
  component: OrderDeliveryDetails,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/OrderConsignmentsBlock/OrderDeliveryDetails/index.js